import type { UseQueryResult } from '@tanstack/react-query';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useSessionUuidAsync } from '#src/app/shared/hooks/session';
import { isLoaded } from '#src/app/shared/utils/async';

import { getMembershipFormData } from '../../formData/api/getMembershipFormData';
import type { MembershipAwarenessFormData } from '../../formData/types';

const QUERY_KEY = 'membership-awareness-form-data';

export function useMembershipAwarenessFormDataQuery(): UseQueryResult<MembershipAwarenessFormData> {
	const sessionUuidState = useSessionUuidAsync();
	const sessionUuid = isLoaded(sessionUuidState) ? sessionUuidState.value : undefined;
	const utilityContext = useUtilityContext();

	return useQuery({
		queryKey: [QUERY_KEY, { sessionUuid }],
		queryFn: async () => getMembershipFormData(utilityContext),
		enabled: !!sessionUuid,
		// matches the previous async-data context, which also kept its loaded value across a session change:
		// without this a re-key empties the cache, unmounting the block and re-sending the once-per-page ask_shown event
		placeholderData: keepPreviousData,
	});
}
